import { axios, base } from '../http';

/** 操作审计分页 */
export const getOperationAuditPage = (params) => {
  return axios.get(`${base}/api/OperationAudit/GetPage`, { params });
};

/** 按需获取单条审计正文，避免列表加载大字段。 */
export const getOperationAuditDetail = (id, startTime) => {
  return axios.get(`${base}/api/OperationAudit/GetDetail`, { params: { id, startTime } });
};

/** 获取审计异步写入队列的运行状态。 */
export const getOperationAuditQueueHealth = () => {
  return axios.get(`${base}/api/OperationAudit/GetQueueHealth`);
};

/** 查询 IP 归属地 */
export const getIpLocation = (ip) => {
  return axios.get(`${base}/api/OperationAudit/GetIpLocation`, { params: { ip } });
};
